import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const LUNA_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'luna'

export const luna = Object.freeze({
  async fetchSettings() {
    const response = await axiosInstance.get(`${LUNA_URL}/${ENTITY}/settings`)
    return response.data
  },
  async updateSettings(id, data) {
    const response = await axiosInstance.put(`${LUNA_URL}/${ENTITY}/settings/${id}`, data)
    return response.data
  },
})
